import React, { useContext, useEffect, useState } from "react";
import styles from "./language.module.css";
import LanguageModal from "./LanguageModal";
import { store } from "../../state/state";

export default function Language() {
  const [showLang, setShowLang] = useState(false);
  const { selectedLang, setSelectedLang } = useContext(store);

  const flags = {
    arm: "/armenian.webp",
    ru: "/russian.webp",
    eng: "/english.webp",
    fr: "/france.webp",
  };

  const langs = {
    arm: "Am",
    ru: "Ru",
    eng: "En",
    fr: "Fr",
  };

  useEffect(() => {
    console.log(showLang)
  }, [showLang])

  const changeLang = (lang, e) => {
    e.stopPropagation()
    setSelectedLang(lang);
    localStorage.setItem("lang", lang);
    setShowLang(false);
    
  }

  const menuModalControll = () => {
    setShowLang((prev) => !prev);
  };

  return (
    <div className={styles["language"]} onClick={menuModalControll}>
      <div className={styles["choosed-language"]}>
        <img src={flags[selectedLang]} alt={selectedLang} />
        {`${langs[selectedLang]}`}
      </div>
      <div
        className={`${styles["modal-scroll"]} ${
          showLang ? styles["show-modal"] : styles["hide-modal"]
        }`}
      >
        <LanguageModal flags={flags} changeLang={changeLang} />
      </div>
    </div>
  );
}
